import { createFileRoute } from '@tanstack/react-router'

import { uomApi } from '@/features/inventory/api/uom-api'
import { UomFormPage } from '@/features/inventory/components/uom-form-page'

export const Route = createFileRoute('/_app/inventory/uom/update/$id/')({
  loader: async ({ params, context }) => {
    const { id } = params
    const { data } = await context.qc.ensureQueryData(uomApi.detail.query({ params: { id } }))
    return {
      crumb: data.uom.code,
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const navigate = Route.useNavigate()

  return (
    <UomFormPage
      mode='update'
      id={id}
      onBack={() => navigate({ to: '/inventory/uom', replace: true })}
    />
  )
}
